<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column :class="{'py-4': $vuetify.breakpoint.smAndDown, 'pa-4': $vuetify.breakpoint.mdAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'mx-3': $vuetify.breakpoint.smAndDown}">
                    <v-icon slot="divider" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                    <v-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :disabled="item.disabled">
                        <v-icon v-if="item.id==1" class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                        {{ $t(item.text) }}
                    </v-breadcrumbs-item>
                </v-breadcrumbs>
                <NoteMain />
            </v-layout>
        </div>
        <FooterBlock />
    </div>
</template>


<script>
// import Mainpage from '../components/blocks/News_main/news_main';
import HeaderMenu from '@/components/blocks/common/Header_menu.vue';
import UserMenu from '@/components/blocks/common/User_menu.vue';
import FooterBlock from '@/components/blocks/common/Footer.vue';
import NoteMain from '../components/blocks/Notifications/notifications_main';
import {mapGetters, mapActions} from 'vuex';

export default {
  components: {
    HeaderMenu, UserMenu, FooterBlock, NoteMain,
  },
  computed: {
    ...mapGetters('notifications/Notifications_bread', [
      'breadcrumbs',
    ]),
    ...mapGetters('notifications/Notifications_items', [
      'push_notifications',
    ]),
  },
  methods: {
    ...mapActions('notifications/Notifications_items', ['get_notifications']),
    async scroll() {
      const path = this.$route.hash.replace('#', '');
      let element = document.getElementById(path);
      element.scrollIntoView({block: 'center', behavior: 'smooth'});
    },
  },
  mounted() {
    this.scroll();
  },
};
</script>

<style>
.bounce-enter-active {
    animation: bounce-in 0.3s;
}

.bounce-leave-active {
    animation: bounce-in 0.3s reverse;
}

@keyframes bounce-in {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>
